module.exports = __webpack_public_path__ + "img/sercomm-view-camera.69c046fc.png";